import reduceColorPointByStep from '../../../../../common/utils/reduce-color-point-by-step';

const dark = (params) => {
  const { targetColor, targetColorPalette } = params;
  const fallback = {
    rule: 'filePicker.button.background.default.dark',
    params,
  };
  if (targetColor.equals(targetColorPalette[50])) {
    return targetColor;
  }
  return reduceColorPointByStep({
    targetColor,
    targetColorPalette,
    step: 1,
    fallback,
  });
};

export default dark;
